import type { TOC } from '@ember/component/template-only'
import { RolloverFinishStep } from 'teacher-ui-client/components/page/rollover/step/finish'
import RouteTemplate from 'ember-route-template'
import type FinishRoute from 'teacher-ui-client/manage/rollover/steps/finish/route'
import type FinishController from 'teacher-ui-client/manage/rollover/steps/finish/controller'

interface Signature {
  Args: {
    model: ModelFor<FinishRoute>
    controller: FinishController
  }
}
export const ManageRolloverStepsFinishPage: TOC<Signature> = <template>
  <RolloverFinishStep @oppositeSubscriptionType={{@controller.oppositeSubscriptionType}} />
</template>

export default RouteTemplate(ManageRolloverStepsFinishPage)
